var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverLicence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624291",
    x: 2.5,
    y: 4.5,
    width: 19,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00744 11.4286C8.9542 11.4286 9.72155 10.6609 9.72155 9.71411C9.72155 8.76735 8.9542 8 8.00744 8C7.06069 8 6.29298 8.76735 6.29298 9.71411C6.28978 10.6577 7.05216 11.4254 7.99536 11.4286H8.00744Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34624292",
    d: "M5.5 15C5.5 14.1716 6.17157 13.5 7 13.5H9C9.82843 13.5 10.5 14.1716 10.5 15V15.5H5.5V15Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 573",
    x1: 13,
    y1: 9.5,
    x2: 19,
    y2: 9.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 574",
    x1: 13,
    y1: 12.5,
    x2: 19,
    y2: 12.5,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 575",
    x1: 13,
    y1: 15.5,
    x2: 19,
    y2: 15.5,
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicence);
export default __webpack_public_path__ + "static/media/driver-licence.d0a7114193d1918d7c5389eb2ad0ce4b.svg";
export { ForwardRef as ReactComponent };